// import EditableTable from '../EditableTable';
import {
  AdminETFDetails,
  AdminETFDetailsTable,
  clearBenchmarkPreview,
  clearIndexFundPreview,
  deleteIndexFund,
  IndexFund,
  requestBenchmarkPreview,
  requestIndexFundPreview,
  selectors,
  updateETFDetails,
  updateIndexFund,
} from 'state';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModal } from 'services';
// import CreateIndexFundModal from './CreateIndexFundModal';
import { Button, Space, Spin } from 'antd';
// import IndexFundPreviewModal from './IndexFundPreviewModal';
import { findRenderedDOMComponentWithClass } from 'react-dom/test-utils';
import EditableTable from './EditableTable';
import { ZoomInOutlined } from '@ant-design/icons';
import { columnSearchWidget, LoadingScreen, TextShortener } from 'components';
import { ETFDetailsModal } from 'reusable';
// import RefreshIndexFundModal from './RefreshIndexFundModal';

const investmentThemeDefaults: Record<string, string | undefined> = {
  category: undefined,
  inverse: undefined,
  leveraged: undefined,
  asset_class: undefined,
  asset_class_size: undefined,
  asset_class_style: undefined,
  sector_general: undefined,
  sector_specific: undefined,
  sector: undefined,
  region_general: undefined,
  region_specific: undefined,
  commodity_type: undefined,
  commodity: undefined,
  commodity_exposure: undefined,
};

const ETFDetailsTab: React.FC = () => {
  const dispatch = useDispatch();
  // const indexFunds = useSelector(selectors.indexFundsList);
  // const indexFundData = useSelector(selectors.indexFundPreviewData);
  const etfDetails = useSelector(selectors.etfDetails);
  const detailsFetching = useSelector(selectors.detailsFetching);
  const underlyingAssets = useSelector(selectors.underlyingAssets);
  const [DetailModal, showDetails] = useModal(ETFDetailsModal);

  if (!Object.values(underlyingAssets).length) {
    return <LoadingScreen />;
  }

  const data = etfDetails.map(details_item => {
    const { investment_theme, id: _ignoredId, ...rest } = details_item; // strip out investment_theme
    const etf_asset = underlyingAssets[details_item.id];
    // const investment_theme = details_item.investment_theme;
    return {
      id: etf_asset.id,
      ric: etf_asset.ric,
      ...rest,
      ...investmentThemeDefaults,
      ...investment_theme,
    };
  });
  // console.log(etfDetails);
  return (
    <>
      <div>Use \t to separate Symbol from Top Holding</div>
      <div>Press Enter after entering a Top Holding or Link entry</div>
      <EditableTable
        pagination={{ defaultPageSize: 5 }}
        loading={detailsFetching}
        data={data}
        onSave={(a: AdminETFDetailsTable) => {
          console.log(a);
          dispatch(updateETFDetails(a));
        }}
        onDelete={(item: AdminETFDetailsTable) => {
          // dispatch(deleteIndexFund(item));
        }}
        nonEditableFields={['id', 'ric']}
        arrayFields={['top_holdings', 'links']}
        first_col_width={'100px'}
        fixedFields={['ric', 'id']}
        columns={{
          id: {
            dataIndex: 'id',
            width: '60px',
            // fixed: 'left',
          },
          ric: {
            dataIndex: 'ric',
            width: '80px',
            ...columnSearchWidget({ dataIndex: 'ric' }),
            // fixed: 'left',
          },
          esg_score: {
            dataIndex: 'esg_score',
            width: '60px',
            // fixed: 'left',
          },
          top_holdings: {
            dataIndex: 'top_holdings',
            width: '500px',
          },
          objectives: {
            dataIndex: 'objectives',
            width: '500px',
          },
          links: {
            dataIndex: 'links',
            width: '150px',
          },
          commodity_exposure: {
            dataIndex: 'commodity_exposure',
            width: '160px',
          },
        }}
        buttons={[
          {
            onClick: record => {
              // setPreviewLoading(true);
              dispatch(requestIndexFundPreview({ index_fund_id: record.id }));
            },
            title: 'Show Details Card',
            render: record => {
              return (
                <Space>
                  <Button
                    onClick={() => {
                      showDetails({ assetId: record.id, refetch: true });
                    }}
                  >
                    <ZoomInOutlined />
                  </Button>
                  {/*{TextShortener({ text, maxLength: 20 })}*/}
                </Space>
              );
            },
          },
        ]}
      />
      {DetailModal}
    </>
  );
};

export default ETFDetailsTab;
